// stick_in_parent.js
$(document).ready(function () {
    $(".directoryNavigationWrap .directoryNavigation").stick_in_parent({
        offset_top: 50
    });
    var bodyHeight = $('body').innerHeight();
    if ( (bodyHeight - 125) <= window.innerHeight ){
        $('.directoryNavigation').addClass('show');
    }
    else{
        $('.directoryNavigation').removeClass('show');
    }

    $(window).resize(function () {
        if ( (bodyHeight - 125) <= window.innerHeight ){
            $('.directoryNavigation').addClass('show');
        }
        else{
            $('.directoryNavigation').removeClass('show');
        }
    });
});
// stick_in_parent.js